'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonContainer from '@components/CommonContainer';
import CustomImage from '@components/CustomImage';
import {
  DesktopBreakpoint,
  MobileBreakpoint,
  TabletBreakpoint,
} from '@components/Breakpoints';

import DynamicHideBlock from '@components/DynamicHideBlock';
import AlGhadeerTitle from '../AlGhadeerTitle';
import AlGhadeerParagraph from '../AlGhadeerParagraph';
import cn from './style.module.scss';
export default function AlGhadeerWelcome(props: MarketingPageComponentProps) {
  const aboutusSection = props?.locale?.section?.find(
    (section: any) => section.type === 'aboutus' && section.enabled
  );
  if (!aboutusSection) return null;

  const aboutElements = aboutusSection?.alghadeerAboutElements || [];
  const bannerData = aboutElements.find((item: any) => item.banner);
  const headingData = aboutElements.find((item: any) => item.heading);
  const contentData = aboutElements.find((item: any) => item.content);
  const storyData = aboutElements.find((item: any) => item.story);

  return (
    <Stack
      component="section"
      className={cn.alGhadeerWelcomeWrapper}
      id="alGhadeerWelcome"
    >
      <Box className={cn.alGhadeerWelcomeInner}>
        <Box className={cn.alGhadeerWelcomeBanner}>
          <MobileBreakpoint>
            <CustomImage
              src={bannerData?.banner?.mobile}
              alt={'AlGhadeer Welcome Banner'}
              width={768}
              height={768}
            />
          </MobileBreakpoint>
          <TabletBreakpoint>
            <CustomImage
              src={bannerData?.banner?.tablet}
              alt={'AlGhadeer Welcome Banner'}
              width={768}
              height={768}
            />
          </TabletBreakpoint>
          <DesktopBreakpoint>
            <CustomImage
              src={bannerData?.banner?.desktop}
              alt={'AlGhadeer Welcome Banner'}
              width={768}
              height={768}
            />
          </DesktopBreakpoint>
        </Box>
        <Box className={cn.alGhadeerWelcomeBlock}>
          <CommonContainer
            maxWidth={{ xs: '100%', md: '100%', lg: '100%' }}
            flexGrow={1}
            paddingInline={{ xs: '1.25rem', md: '5%', lg: '10%' }}
          >
            <Box className={cn.alGhadeerWelcomeContent}>
              <Box className={cn.welcomeStoryHeading}>
                <AlGhadeerTitle titleData={headingData?.heading} />
              </Box>
              <Box className={cn.alGhadeerWelcomeText}>
                {contentData?.content?.map(
                  (paragraph: string, index: number) => (
                    <AlGhadeerParagraph paragraphData={paragraph} key={index} />
                  )
                )}
              </Box>
            </Box>
          </CommonContainer>
        </Box>
        <DynamicHideBlock data={storyData?.story}>
          <Box className={cn.alGhadeerWelcomeStory}>
            <CommonContainer
              maxWidth={{ xs: '100%', md: '100%', lg: '100%' }}
              flexGrow={1}
              paddingInline={{ xs: '1.25rem', md: '5%', lg: '10%' }}
            >
              <Box className={cn.welcomeStoryElement}>
                <MobileBreakpoint>
                  <CustomImage
                    src={storyData?.story?.mobile}
                    alt={'AlGhadeer Welcome Story'}
                    width={768}
                    height={768}
                  />
                </MobileBreakpoint>
                <TabletBreakpoint>
                  <CustomImage
                    src={storyData?.story?.tablet}
                    alt={'AlGhadeer Welcome Story'}
                    width={768}
                    height={768}
                  />
                </TabletBreakpoint>
                <DesktopBreakpoint>
                  <CustomImage
                    src={storyData?.story?.desktop}
                    alt={'AlGhadeer Welcome Story'}
                    width={768}
                    height={768}
                  />
                </DesktopBreakpoint>
              </Box>
            </CommonContainer>
          </Box>
        </DynamicHideBlock>
      </Box>
    </Stack>
  );
}
